/** The P&L table's display helpers (TMMAPP-0111): per-kind subtotals and row totals. */
import type { PnlCategoryRow } from '@/api/pnl';

/** A kind's subtotal per month: its category rows plus its Uncategorized row (display only). */
export function subtotalCells(rows: PnlCategoryRow[], uncategorized: number[]): number[] {
  return uncategorized.map((cell, index) =>
    rows.reduce((sum, row) => sum + (row.cells[index] ?? 0), cell),
  );
}

/** A row's total from its months. */
export function totalOf(cells: number[]): number {
  return cells.reduce((sum, cell) => sum + cell, 0);
}
